<template>
  <v-tabs v-model="tab" background-color="primary" grow>
    <v-tab v-for="skill in skills" :key="skill.uid">{{ skill.text }}</v-tab>
    <v-tab-item v-for="(skill, i) in skills" :key="i + skill.uid">
      <v-lazy>
        <CreateLevel v-model="result[skill.value]" />
      </v-lazy>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import CreateLevel from "./CreateAssessmentLevel";
import GenKey from "@/common/genkey.js";
export default {
  name: "CreateSkill",
  props: {
    value: {
      type: Object
    }
  },
  components: {
    CreateLevel
  },
  data() {
    return {
      tab: 0,
      skills: [
        { uid: GenKey(), text: "samtala", value: "samtala" },
        { uid: GenKey(), text: "Berätta", value: "beratta" },
        { uid: GenKey(), text: "Lyssna", value: "lyssna" },
        { uid: GenKey(), text: "Skriva", value: "skriva" },
        { uid: GenKey(), text: "Läsa", value: "lasa" }
      ]
    };
  },
  computed: {
    result: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style></style>
